import React, { useState, useCallback } from "react";
import "./ImageCard.css";
import { Card, Img, Imgoverlay } from "react-bootstrap";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import { GrClose } from "react-icons/gr";
import ImageViewer from "react-simple-image-viewer";

function ImageCard2(props) {
  //Image Viewer
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const images = [
    "./images/Gallery/category2-img1.png",
    "./images/Gallery/category2-img2.png",
    "./images/Gallery/category2-img3.png",
  ];

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  // Modal Dialog
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      {/* Card */}
      <a className="hyperlink__Cards" onClick={() => setModalIsOpen(true)}>
        <Card className="bg-dark text-white cardMain">
          <Card.Img
            className="CardImage__Container"
            src={props.cardImage}
            alt="Card image"
          />
          <div className="imagecard__overlay">
            <h2 className="text">{props.heading}</h2>
          </div>
        </Card>
      </a>
      {/* Modal Dialog */}
      <div>
        <Modal
          style={{
            overlay: { backgroundColor: "grey" },
            content: { backgroundColor: "lightgrey" },
          }}
          shouldCloseOnOverlayClick={false}
          onRequestClose={() => setModalIsOpen(false)}
          isOpen={modalIsOpen}
        >
          <button
            className="close__button"
            onClick={() => setModalIsOpen(false)}
          >
            <GrClose />
          </button>
          <Container>
            <h2 className="modal__heading">{props.heading}</h2>
            <hr></hr>
          </Container>
          <Container className="modal__dialog">
            {images.map((src, index) => (
              <img
                src={src}
                onClick={() => openImageViewer(index)}
                width="300"
                key={index}
                style={{ margin: "2px" }}
                alt=""
              />
            ))}

            {isViewerOpen && (
              <ImageViewer
                src={images}
                currentIndex={currentImage}
                disableScroll={false}
                closeOnClickOutside={true}
                onClose={closeImageViewer}
              />
            )}
          </Container>
          <button
            onClick={() => setModalIsOpen(false)}
            className="close__button_bottom"
          >
            close
          </button>
        </Modal>
      </div>
    </>
  );
}

export default ImageCard2;
